import {combineReducers} from 'redux'

import {
    eventcategorydata,
    seteventcategorydata,
    eventoccurrencesdata,
    eventdata,
    occurrencedata,
    lookupdata,
    lookupEUIDdata,
    swipedata,
    batchswipedata,
    swipeteamdata,
    engagementtypedata,
    departmentsdata,
    departmentusersdata,
    superadminsdata,
} from './datafetch.reducer'
import {authentication} from './authentication.reducer'
import {alert} from './alert.reducer'
import {userConstants} from '../constants'

const appReducer = combineReducers({
    alert,
    authentication,
    eventcategorydata,
    seteventcategorydata,
    eventoccurrencesdata,
    eventdata,
    occurrencedata,
    lookupdata,
    lookupEUIDdata,
    swipedata,
    batchswipedata,
    swipeteamdata,
    engagementtypedata,
    departmentsdata,
    departmentusersdata,
    superadminsdata,
})

// set store state to undefined when Logout action is detected
const rootReducer = (state, action) => {
    if (action.type === userConstants.LOGOUT) {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer
